import formatChoice from "./formatChoice";

function formatFreeTextResponse(value: string) {
  if (value) {
    return "Answered";
  }
  return "Empty";
}

export function formatResponse(questionType: string | undefined, data: any): string {
  switch (questionType) {
    case "PreviousMigraineTreatmentQuestion":
      return [
        "triptans: " + formatChoice(data.hasTriedTriptans),
        "relief: " + formatChoice(data.hasExperiencedRelief),
        "side-effects: " + formatChoice(data.hasExperiencedSideEffects),
      ].join("; ");
    case "FreeTextMedicalQuestion":
      return [
        "Any: " + formatChoice(data.takingAny),
        "Contraindicated: " + formatChoice(data.takingContraindicated),
        "Other Medicines: " + formatFreeTextResponse(data.otherMedicinesTaken),
      ].join("; ");
    case "CustomFreeTextMedicalQuestion":
      return [
        "Response: " + formatChoice(data.responseYes),
        "Free Text Response: " + formatFreeTextResponse(data.freeTextResponse),
      ].join("; ");
    case "MedicalQuestion":
      return [
        "any: " + formatChoice(data.takingAny),
        "contraindicated: " + formatChoice(data.takingContraindicated),
      ].join("; ");
    case "BloodPressureQuestion":
      return formatChoice(data.recentReading);
    case "WarningQuestion":
    case "YesNoQuestion":
    case "DateQuestion":
      return formatChoice(data.response);
    case "SingleSelectQuestion":
      return data.response;
    case "MultiSelectQuestion":
      return data.response;
    case "PhotoUploadQuestion":
      return `Photo Uploaded: ${data?.responseImageKey ? "Yes" : "No"}`;
    default:
      return "empty";
  }
}
